"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopularCountryOption = void 0;

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PopularCountryOption = function PopularCountryOption(_ref) {
  var label = _ref.label,
      visa = _ref.visa;
  var hasVisa = !(0, _isEmpty2["default"])(visa);
  return /*#__PURE__*/_react["default"].createElement(Row, {
    $hasVisa: hasVisa
  }, /*#__PURE__*/_react["default"].createElement(PopularCountryDescription, null, /*#__PURE__*/_react["default"].createElement(_styles.TitleBlock, null, /*#__PURE__*/_react["default"].createElement(_styles.ContainerText, null, /*#__PURE__*/_react["default"].createElement(_styles.LabelText, null, label), hasVisa && /*#__PURE__*/_react["default"].createElement(_styles.SubtitleBlock, null, visa)))));
};

exports.PopularCountryOption = PopularCountryOption;

var PopularCountryDescription = _styledComponents["default"].div.withConfig({
  displayName: "PopularCountryOption__PopularCountryDescription",
  componentId: "sc-wy83rx-0"
})(["position:absolute;top:0;left:0;right:0;bottom:0;padding:8px;z-index:1;"]);

var Row = _styledComponents["default"].div.withConfig({
  displayName: "PopularCountryOption__Row",
  componentId: "sc-wy83rx-1"
})(["height:", "px;"], function (_ref2) {
  var $hasVisa = _ref2.$hasVisa;
  return $hasVisa ? 48 : 30;
});